// extracted by mini-css-extract-plugin
export default {"p_content":"f403b1a1bd"};